export const price = (price) => {
  if (isNaN(price)) {
    return 0
  }
  return Math.round(price * 1.47 * 100) / 100
}
